// extracted by mini-css-extract-plugin
module.exports = {"button":"Link__button--24c1P4h-1HZtUxCsfO_HrX"};